import { FASTGPT_BASE } from '@/config/api';

const API = `${FASTGPT_BASE}/api/fastgpt`;

export async function askFastGPT(question: string) {
  const res = await fetch(`${API}/ask`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ question }),
  });
  if (!res.ok) throw new Error(`请求失败 ${res.status}`);
  return res.json();
}

export async function chatWithFastGPT(prompt: string, history: any[] = []) {
  const res = await fetch(`${API}/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ prompt, history }),
  });
  return res.json();
}

export async function openaiChat(messages: any[], stream = false) {
  const res = await fetch(`${API}/openai/chat/completions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ messages, stream }),
  });
  if (stream) return res.body;
  return res.json();
}
